import React from 'react';

/**
 * Radio group with explicit option labels, stacked vertically.
 *
 * Used where the compliance questions need full-sentence answers
 * ("No, I want to opt out of paperless document delivery…") rather than
 * the bare Yes/No that `YesNoRadio` renders.
 *
 * @param {string} id
 * @param {React.ReactNode} label
 * @param {Array<{value: string, label: string}>} options
 * @param {string} value
 * @param {function} onChange
 */
export default function ChoiceRadio({
  id,
  label,
  help,
  options = [],
  value,
  onChange,
  inline = false,
}) {
  return (
    <div className="mb-3">
      {label && <div className="form-label small fw-semibold">{label}</div>}
      {help && <p className="text-muted small mb-2">{help}</p>}
      <div>
        {options.map((opt) => (
          <div
            className={`form-check${inline ? ' form-check-inline' : ''}`}
            key={opt.value}
          >
            <input
              className="form-check-input"
              type="radio"
              id={`${id}_${opt.value}`}
              name={id}
              checked={value === opt.value}
              onChange={() => onChange(opt.value)}
            />
            <label className="form-check-label" htmlFor={`${id}_${opt.value}`}>
              {opt.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
